<template>
  <div class="note-legend-container">
    <div class="note-legend">
      <span><strong>Legend</strong></span>
      <span>
        <img
          class="note-icon"
          src="/images/icons/view_notes.svg"
          title="View Notes"
        >
        - View Notes
        <img
          class="note-icon"
          src="/images/icons/note_add.svg"
          title="Add Note"
        >
        - Add Note
      </span>
      <span>
        <img
          class="note-icon"
          src="/images/icons/action-menu.svg"
          title="Actions Menu"
        >
        - Actions Menu
        <img
          class="note-icon"
          src="/images/icons/see_in_context.svg"
          title="Actions Menu"
        >
        - See in Context
      </span>
      <span v-if="userHasTranslationPerm">
        <img
            src="/images/icons/icon-translate.svg"
            title="Translate to English via AI"
        >
        - Translate to English via AI
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotesLegend',
  data(){
    return {
      userHasTranslationPerm: false,
    }
  },
  mounted() {
    this.userHasTranslationPerm = !!window.can_translate_content_using_ai
  }
}
</script>

<style>
.note-legend-container {
  position: relative;
  height: 140px;
}
.note-legend {
  font-size: 14px;
  text-align: center;
  margin-bottom: 4px;
  width: 250px;
  position: absolute;
  right: 0;
}
.note-legend span {
  display: block;
  padding: 4px 0;
}
.note-legend span:first-child {
  border-bottom: 1px solid #ccc;
}
.note-legend img {
  width: 20px;
}
</style>
